// extracted by mini-css-extract-plugin
export default {"container":"styles_container__bOcXX","cards":"styles_cards__cb2SO","card":"styles_card__2zXo2"};